export { notifyCameraSubstituted } from './cameraSubstitutionNotice.any';
/**
 * The page's own dispatch, when a room store exists (web rooms). Returns
 * undefined elsewhere (tests, pages without the app), so callers can pass it
 * through without guarding.
 *
 * @returns {Function|undefined}
 */
export function roomDispatch() {
    return typeof APP !== 'undefined' && APP?.store?.dispatch ? APP.store.dispatch : undefined;
}
